export const INCREMENT_LOADING_STATE = 'INCREMENT_LOADING_STATE';
export const DECREMENT_LOADING_STATE = 'DECREMENT_LOADING_STATE';
export const SET_PREVENT_LOADING = 'SET_PREVENT_LOADING';
